import {
    Box,
    Grid,
    GridProps,
    Heading,
    Spacer,
    Text,
} from '@chakra-ui/react';
import { Image } from 'shared';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';
import { CartAddButtonWithCounter } from 'features';

/**
 * Пропсы для компонента карточки позиции магазина
 */
export type ArticleCardProps = {
    type: 'delivery' | 'sweet-shop',
    uid: string,
    image?: {
        url: string
    },
    name: string,
    link?: {
        url: string
    },
    description?: {
        content: any
    },
    weight?: number
    price?: number
    currencyAbbreviation?: string
} & GridProps & React.RefAttributes<HTMLDivElement>

/**
 * Компонент карточки для позиции магазина
 *
 * @param {ArticleCardProps} props Пропсы
 * @returns Компонент
 */
export const ArticleCard: React.FC<ArticleCardProps> = ({
    type,
    uid,
    image,
    name,
    link,
    weight,
    price,
    currencyAbbreviation,
    ...props
}) => (
    <Grid
        templateRows="auto"
        key={uid}
        gap="1.25rem"
        {...props}
    >
        <Link to={link?.url || ''}>
            <Grid templateRows="auto auto 1fr" gap="1.25rem">
                <Image
                    src={image?.url}
                    aspectRatio="3 / 2"
                    objectFit="cover"
                    widows="100%"
                />
                <Heading
                    size="md"
                    textDecoration="underline"
                    colorScheme="primary"
                    lineClamp={2}
                >
                    {name}
                </Heading>
                <Grid
                    templateColumns="auto 1fr"
                    gap="1rem"
                >
                    <Box width="3px" background="#000000" height="100%" />
                    <Grid
                        gap="2rem"
                        templateColumns="1fr auto"
                    >
                        {weight ? (
                            <Text
                                fontSize="1rem"
                            >
                                Вес:
                                {' '}
                                {weight}
                                г
                            </Text>
                        ) : (
                            <Spacer />
                        )}
                        <Text
                            fontSize="2rem"
                        >
                            {price ? (
                                price.toLocaleString()
                            + currencyAbbreviation
                            ) : (
                                'Не указано'
                            )}
                        </Text>
                    </Grid>
                </Grid>
            </Grid>
        </Link>
        <Spacer />
        <CartAddButtonWithCounter
            type={type}
            uid={uid}
        />
    </Grid>
);
